<template>
    <div>
        <v-row>
            <v-col>
                <date-picker v-model="date"
                             type="date"
                             format="YYYY-MM-DD"
                             display-format="jYYYY-jMM-jDD"
                             :timezone="false"
                             auto-submit
                             label="تاریخ ارسال"
                             required
                             endTime></date-picker>
            </v-col>
            <v-col>
                <date-picker v-model="start"
                             type="time"
                             format="HH:mm"
                             display-format="HH:mm"
                             :timezone="false"
                             auto-submit
                             label="ساعت شروع"
                             endTime></date-picker>
            </v-col>
            <v-col>
                <date-picker v-model="end"
                             type="time"
                             format="HH:mm"
                             display-format="HH:mm"
                             :timezone="false"
                             auto-submit
                             label="ساعت پایان"
                             endTime></date-picker>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import Swal from "sweetalert2";
import {Bus} from "@/main";

export default {
    name: "multiTimes",
    props: {
        autoGradual: {
            default: false
        }
    },
    data() {
        return {
            date: '',
            nowTime: '',
            start: '',
            end: '',
            times: {
                started: '',
                end: ''
            }
        }
    },
    methods: {
        getTimesForNow() {
            $.ajax({
                url: `${url}/setting/clock`,
                type: 'GET',
                fn: this.getTimesForNow,
                headers: {
                    "ACCEPT": "application/json",
                    "Authorization": Token
                },
                success: (data) => {
                    this.nowTime = data.data.time_stamp;
                }
            });
        }
    },
    watch: {
        start: function (value) {
            this.times.started = Date.parse(this.date + ' ' + value) / 1000;
            if (this.times.started <= this.nowTime) {
                Swal.fire({
                    title: 'خطا',
                    text: 'زمان ارسال باید بزرگتر از زمان حال باشد',
                    icon: 'error',
                    confirmButtonText: 'باشه'
                }).then(() => {
                    this.start = '';
                })
            }
        },
        end: function (value) {
            this.times.end = Date.parse(this.date + ' ' + value) / 1000;

            if (this.times.end <= this.times.started) {
                Swal.fire({
                    title: 'خطا',
                    text: 'زمان پایان باید بزرگتر از زمان ارسال باشد',
                    icon: 'error',
                    confirmButtonText: 'باشه'
                }).then(() => {
                    this.end = '';
                })
            }
        },
        times: {
            handler: function () {
                Bus.$emit('getTimeMode', this.times, this.$vnode.key)
            },
            deep: true
        },
        autoGradual: function (val) {
          this.start = ''
          this.date = ''
          this.end = ''
          this.times.started = ''
          this.times.end = ''
        }
    },
    mounted() {
        this.getTimesForNow()
    }
}
</script>

<style scoped>

</style>